/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_EmptyInputs */

const en_us2_progress_empty = /** @type {(inputs: Progress_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your progress shows up here after your first session.`)
};

const pt_br2_progress_empty = /** @type {(inputs: Progress_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu progresso aparece aqui depois do primeiro treino.`)
};

const es_419_progress_empty = /** @type {(inputs: Progress_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu progreso aparece aquí después de tu primer entrenamiento.`)
};

const pt_pt2_progress_empty = /** @type {(inputs: Progress_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu progresso aparece aqui depois do primeiro treino.`)
};

const fr_fr2_progress_empty = /** @type {(inputs: Progress_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes progrès s'affichent ici après ta première séance.`)
};

const de_de2_progress_empty = /** @type {(inputs: Progress_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Fortschritt erscheint hier nach deiner ersten Einheit.`)
};

const it_it2_progress_empty = /** @type {(inputs: Progress_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi progressi compaiono qui dopo il primo allenamento.`)
};

/**
* | output |
* | --- |
* | "Your progress shows up here after your first session." |
*
* @param {Progress_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_empty = /** @type {((inputs?: Progress_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_empty(inputs)
	if (locale === "es-419") return es_419_progress_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_empty(inputs)
	return en_us2_progress_empty(inputs)
});
export { progress_empty as "progress.empty" }